import React from 'react';
import {
  TechDocsReaderPageContent,
  TechDocsReaderPageSubheader,
} from '@backstage/plugin-techdocs';
import {
  FullPage,
  PageHeader,
  MaterialIcon,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { Progress, ResponseErrorPanel } from '@backstage/core-components';
import { Entity } from '@backstage/catalog-model';

export type TechdocReaderProps = {
  entityMetadata: {
    value?: Entity; // Optional to handle errors
    loading: boolean;
    error?: Error; // Add error type
  };
};

export const TechdocsReader = (
  props: TechdocReaderProps,
): React.ReactElement => {
  const { value: entity, loading, error } = props.entityMetadata;

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  if (!entity) {
    return <div>No entity found.</div>;
  }

  return (
    <FullPage
      variant="card"
      HeaderComponent={() => (
        <PageHeader
          subtitle={entity.metadata.title ?? 'TechDocs'}
          title="Documentation"
          icon={<MaterialIcon.menu_book />}
        />
      )}
      hideFooter
      disableGutters
    >
      <TechDocsReaderPageSubheader />
      <TechDocsReaderPageContent />
    </FullPage>
  );
};
